export async function getAllTerms(taxonomy) {

    const url = `${window.location.origin}/wp-json/adw/v1/terms/${taxonomy}`;

    try {

        const res = await fetch( url );

        return await res;

    } catch (e) {

        console.error(`Developer message: Error in fetching all the terms for ${taxonomy} taxonomy: ` + e);

        throw e;

    }

}
